import { createElementBlock as n, openBlock as r, createElementVNode as o } from "vue";
const t = {
  fill: "none",
  viewBox: "0 0 23 23"
};
function l(s, e) {
  return r(), n("svg", t, [...e[0] || (e[0] = [
    o("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M3.5 11.5a8 8 0 1 0 16 0 8 8 0 0 0-16 0"
    }, null, -1),
    o("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.992 19.358c-1.116-1.565-1.87-4.502-1.87-7.822s.754-6.33 1.87-7.858m3.016 15.68c1.116-1.565 1.87-4.502 1.87-7.822s-.754-6.33-1.87-7.858M3.5 11.5h16M4.424 15.234h14.151M4.424 7.766h14.151"
    }, null, -1)
  ])]);
}
const u = { render: l };
export {
  u as default,
  l as render
};
